import { ViewMode } from '../model-entity-views/shared/view-modes';

type PathPartReplacement = {
  before: string;
  after: string;
};

const allLegacyPathParts: PathPartReplacement[] = [
  { before: '/breakdown/', after: '/drilldown/' },
  { before: '/portfolio-new/', after: '/portfolio/' },
];

type LensReplacements = {
  oldLensValue: string;
  newPathName: string;
};

const allLegacyLensParams: LensReplacements[] = [{ oldLensValue: 'materiality', newPathName: ViewMode.CSRD }];

export function replaceLegacyUrlParts() {
  const { pathname, search, hash } = window.location;

  const pathnameWithUpdatedParts = updatePathParts(pathname);
  const [updatedPathname, updatedSearch] = replaceLegacySearchParams(pathnameWithUpdatedParts, search);

  const updatedUrl = `${updatedPathname}${updatedSearch}${hash}`;
  window.history.replaceState(window.history.state, window.document.title, updatedUrl);
}

function updatePathParts(pathname: string) {
  return allLegacyPathParts.reduce((partiallyUpdatedPath, legacyPathPart) => {
    return partiallyUpdatedPath.replace(legacyPathPart.before, legacyPathPart.after);
  }, pathname);
}

function replaceLegacySearchParams(pathname: string, search: string) {
  const [updatedPathname, updatedSearch] = replaceLensParamsWithPaths(pathname, search);
  return [updatedPathname, updatedSearch];
}

function replaceLensParamsWithPaths(pathname: string, search: string) {
  const searchParams = new URLSearchParams(search);
  for (const legacyLensParam of allLegacyLensParams) {
    if (searchParams.has('lens', legacyLensParam.oldLensValue)) {
      searchParams.delete('lens', legacyLensParam.oldLensValue);

      const newPathName = `${stripTrailingSlash(pathname)}/${legacyLensParam.newPathName}/`;
      return [newPathName, ''];
    }
  }
  return [pathname, search];
}

function stripTrailingSlash(str: string) {
  return str.endsWith('/') ? str.slice(0, -1) : str;
}
